import React from 'react';
import { Button, ButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { st, classes } from '../MainToolBar.st.css';
import { AddFolderStatus } from '../../../../../../Observables/AddNewFolder.observable';
import { setAddFolderStatus } from '../../../../../../Services/AddNewFolder.service';
import withMemberAuthorization from '../../../../../../../Shared/HOC/withMemberAuthorization';
import biService from '../../../../../../BiEvents/BiService';
import { BI_FILE_SHARE_WIDGET_NEW_FOLDER_CLICK } from '../../../../../../BiEvents/Constants/BiConstants';
import { handleMemberAuth } from '../../../../../../Shared/memberAuthorizationHelper';
import { useAppContext } from '../../../../../../Shared/AppContext';

const FolderButton = (props: any) => {
  const {
    memberAuthorization,
    folderPermissions,
    openPrivacyModal,
    isCreateFolderDisabled,
    isMobile,
  } = props;
  const { t } = useTranslation();
  const { compId } = useAppContext();
  const title = t('app.widget.header.folder.button');

  const handleFolderClick = () => {
    handleMemberAuth({
      permissions: folderPermissions,
      callBack: setAddFolderStatus,
      openPrivacyModal,
      memberAuthorization,
      memberAuthorizationArgs: [AddFolderStatus.OPENED, compId],
    });
    biService(
      { is_first: false },
      BI_FILE_SHARE_WIDGET_NEW_FOLDER_CLICK,
      compId,
    );
  };
  return (
    <>
      <Button
        upgrade
        className={st(classes.folderButton, { isMobile })}
        disabled={isCreateFolderDisabled}
        onClick={handleFolderClick}
        priority={ButtonPriority.secondary}
      >
        {title}
      </Button>
    </>
  );
};

export default withMemberAuthorization(FolderButton);
